import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconNook16(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={16}
            height={16}
            className={customClassName}
            name="IconNook16"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M13.776 10.458a.5.5 0 0 1 .222.416v.877L8.5 8.791v-6.3l.765.479a.5.5 0 0 1 .235.424V4.75a1.5 1.5 0 0 0 .771 1.311l1.221.678a.5.5 0 0 1 .258.437v1.126c0 .502.25.97.667 1.249zM7.499 8.79 2 11.751v-.877a.5.5 0 0 1 .223-.416l1.359-.906a1.5 1.5 0 0 0 .668-1.249V7.177a.5.5 0 0 1 .257-.437l1.22-.678A1.5 1.5 0 0 0 6.5 4.751V3.394a.5.5 0 0 1 .235-.424l.765-.478zm-4.957 3.805 5.457-2.938 5.457 2.938-.99.55a.5.5 0 0 1-.466.01l-1.105-.553a1.5 1.5 0 0 0-1.28-.03l-1.413.629a.5.5 0 0 1-.406 0l-1.412-.628a1.5 1.5 0 0 0-1.28.029l-1.106.553a.5.5 0 0 1-.467-.01zm12.456-1.721a1.5 1.5 0 0 0-.668-1.248l-1.359-.907a.5.5 0 0 1-.223-.416V7.177a1.5 1.5 0 0 0-.771-1.31l-1.221-.68a.5.5 0 0 1-.257-.436V3.394a1.5 1.5 0 0 0-.705-1.272l-1.53-.956L8 1l-.265.166-1.53.956A1.5 1.5 0 0 0 5.5 3.394V4.75a.5.5 0 0 1-.257.437l-1.22.678a1.5 1.5 0 0 0-.772 1.311v1.126a.5.5 0 0 1-.223.416l-1.359.907A1.5 1.5 0 0 0 1 10.874v2.008l.257.143 1.789.994a1.5 1.5 0 0 0 1.4.03l1.105-.553a.5.5 0 0 1 .427-.01l1.412.628a1.5 1.5 0 0 0 1.218 0l1.413-.627a.5.5 0 0 1 .426.01l1.106.552a1.5 1.5 0 0 0 1.4-.03l1.788-.994.257-.143z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconNook16);
